import { useEffect, useState } from 'react'

export function useAutoCarousel(slideCount: number, autoplayMs: number) {
  const [index, setIndex] = useState(0)
  const [paused, setPaused] = useState(false)

  const safeCount = Math.max(slideCount, 1)
  const activeIndex = index % safeCount

  useEffect(() => {
    setIndex(0)
  }, [slideCount])

  useEffect(() => {
    if (paused || safeCount <= 1) return undefined

    const timer = window.setInterval(() => {
      setIndex((current) => (current + 1) % safeCount)
    }, autoplayMs)

    return () => window.clearInterval(timer)
  }, [paused, safeCount, autoplayMs])

  function goTo(next: number) {
    setIndex(((next % safeCount) + safeCount) % safeCount)
  }

  return {
    activeIndex,
    goTo,
    goNext: () => goTo(activeIndex + 1),
    goPrev: () => goTo(activeIndex - 1),
    pause: () => setPaused(true),
    resume: () => setPaused(false),
    canNavigate: safeCount > 1,
  }
}
